import React from "react";
const BottomLine=()=>{
    const css={
        width: '100%',
        height: '1px',
        margin: '9px 0 0',
        backgroundColor: '#e4e4e4',
    }
    return(
        <>
            <div style={css}>
            </div>
        </>
    );
}
export default BottomLine;